import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import Modal from 'components/ui/Modal';
import Switch from 'components/ui/Switch';
import Button, { ButtonType } from 'components/ui/Button';

interface Props {
  open: boolean;
  buttonText: MessageDescriptor;
  onClick: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const PendingModal: React.FC<Props> = ({
  open, loading, buttonText, onClick, onCancel,
}) => {
  const ref = React.useRef(null);
  const [isConfirmed, setIsConfirmed] = React.useState(false);

  const handleClick = () => {
    setIsConfirmed(false);
    onClick();
  };

  const handleCancel = () => {
    setIsConfirmed(false);
    onCancel();
  };

  return (
    <Modal
      role="alertdialog"
      focusRef={ref}
      open={open}
      className="modal-large"
      title={(
        <FormattedMessage
          id="page.finalInvoice.modal.pending.title"
          defaultMessage="Payment in progress"
          tagName="h2"
        />
      )}
    >
      {loading && <span className="loader w-6! h-6!" />}
      {!loading && (
        <div data-testid="pending-payment-warning-modal" className="flex flex-col items-center mt-5 kiosk:mt-10">
          <FormattedMessage
            id="page.finalInvoice.modal.pending.content"
            defaultMessage="A payment is pending. Be aware that processing time to validate the payment can take some time. Proceed to payment a second time only if you are sure that your payment has been rejected."
            tagName="p"
          />
          {/* The modal content is centered: this wrapper keeps the switch left-aligned with the text. */}
          <div className="w-full mt-4 kiosk:mt-8">
            <Switch
              data-testid="pending-payment-confirm"
              checked={isConfirmed}
              onChange={setIsConfirmed}
              labelClassName="[&>span]:[font-size:inherit]"
            >
              <FormattedMessage
                id="page.finalInvoice.modal.pending.confirm"
                defaultMessage="I confirm that I understand I may be making a second payment"
              />
            </Switch>
          </div>
          <div className="flex flex-col kiosk:flex-row w-full mt-4 kiosk:mt-10">
            <Button onClick={handleClick} disabled={!isConfirmed} testId="pay-button-modal" className="w-full mt-5 mb-3 kiosk:mr-5 kiosk:my-0">
              <FormattedMessage {...buttonText} />
            </Button>
            <Button
              type={ButtonType.SECONDARY}
              ref={ref}
              onClick={handleCancel}
              className="w-full kiosk:ml-5"
              testId="back-button-modal"
            >
              <FormattedMessage id="steps.back" defaultMessage="Back" />
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default PendingModal;
